<template>
    <li :class="li_class">
        <router-link :to="{ path: url }">
            <span>
                <p>{{ label_ja }}</p>
                <p>{{ label_en }}</p>
            </span>
        </router-link>
    </li>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "Mytab",
    props: {
        li_class: {
            type: String,
            required: true,
            default: "link_01",
        },
        url: {
            type: String,
            required: true,
            default: "/",
        },
        label_ja: {
            type: String,
            default: "すべて'",
        },
        label_en: {
            type: String,
            default: "All Database",
        },
    },
});
</script>

<style scoped>
.link_01 span {
    background-image: url("../../../../public/images/search_link_01.png");
}
.link_01_current span {
    background-image: url("../../../../public/images/search_link_off_01.png");
}
.link_02 span {
    background-image: url("../../../../public/images/search_link_02.png");
}
.link_02_current span {
    background-image: url("../../../../public/images/search_link_off_02.png");
}
.link_06 span {
    background-image: url("../../../../public/images/search_link_06.png");
}
.link_06_current span {
    background-image: url("../../../../public/images/search_link_off_06.png");
}
.link_07 span {
    background-image: url("../../../../public/images/search_link_07.png");
}
.link_07_current span {
    background-image: url("../../../../public/images/search_link_off_07.png");
}
.link_01_current span p,
.link_02_current span p,
.link_06_current span p,
.link_07_current span p {
    color: #fff;
}
</style>
